import { ErrorMessage } from "formik";
import { Col, FormGroup, Label, Row } from "reactstrap";
import { placeholderNoOptions } from "../../../../shared/helpers/placeHolders";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { to_ISelect_Enum } from "../../../../shared/mutator/dataTransformSelect";
import { yesNoEnum } from "../../../../shared/selectors/yesNoEnum";
import { customStyles } from "../custom-selector-styles";

interface IProps {
  formik: any;
  showErrorsInputs: boolean;
}

const animatedComponents = makeAnimated();

export const DisabilityData = (props: IProps) => {
  const { formik, showErrorsInputs } = props;

  return (
    <>
      {/* DISCAPACIDAD */}
      <Row className="title-form not-first-title">Discapacidad</Row>
      <Row className="container-inputs-form">
        <Col>
          <FormGroup>
            <Label
              id="disabilityLabel"
              for="candidateMedicalInformation.disability"
              className={
                (showErrorsInputs || formik.touched?.candidateMedicalInformation?.disability) &&
                formik.errors?.candidateMedicalInformation?.disability &&
                "text-danger"
              }
            >
              ¿Tienes algún tipo de discapacidad?*
            </Label>
            <Select
              name="candidateMedicalInformation.disability"
              placeholder={""}
              noOptionsMessage={() => placeholderNoOptions()}
              components={animatedComponents}
              options={yesNoEnum()}
              value={to_ISelect_Enum(
                formik.values.candidateMedicalInformation.disability,
                yesNoEnum()
              )}
              onChange={(e: any) => {
                formik.setFieldValue(
                  "candidateMedicalInformation.disability",
                  e.value
                );
              }}
              onBlur={formik.handleBlur(
                "candidateMedicalInformation.disability"
              )}
              className={`select-postulate ${
                (showErrorsInputs || formik.touched?.candidateMedicalInformation?.disability) &&
                formik.values?.candidateMedicalInformation?.disability ===
                  null &&
                "is-invalid"
              }`}
              styles={customStyles}
            />
            {(showErrorsInputs || formik.touched?.candidateMedicalInformation?.disability) &&
              formik.values?.candidateMedicalInformation?.disability ===
                null && (
                <div className="invalid-feedback">
                  {formik.errors.candidateMedicalInformation.disability}
                </div>
              )}
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label
              id="disabilityCertificateLabel"
              for="candidateMedicalInformation.disabilityCertificate"
              className={
                (showErrorsInputs || formik.touched?.candidateMedicalInformation?.disabilityCertificate) &&
                formik.errors?.candidateMedicalInformation
                  ?.disabilityCertificate &&
                "text-danger"
              }
            >
              ¿Cuentas con certificado?*
            </Label>
            <Select
              name="candidateMedicalInformation.disabilityCertificate"
              placeholder={""}
              noOptionsMessage={() => placeholderNoOptions()}
              components={animatedComponents}
              options={yesNoEnum()}
              value={to_ISelect_Enum(
                formik.values.candidateMedicalInformation.disabilityCertificate,
                yesNoEnum()
              )}
              onChange={(e: any) => {
                formik.setFieldValue(
                  "candidateMedicalInformation.disabilityCertificate",
                  e.value
                );
              }}
              onBlur={formik.handleBlur(
                "candidateMedicalInformation.disabilityCertificate"
              )}
              className={`select-postulate ${
                (showErrorsInputs || formik.touched?.candidateMedicalInformation?.disabilityCertificate) &&
                formik.values?.candidateMedicalInformation
                  ?.disabilityCertificate === null &&
                "is-invalid"
              }`}
              styles={customStyles}
            />
            {(showErrorsInputs || formik.touched?.candidateMedicalInformation?.disabilityCertificate) &&
              formik.values?.candidateMedicalInformation
                ?.disabilityCertificate === null && (
                <div className="invalid-feedback">
                  {formik.errors.candidateMedicalInformation.disabilityCertificate}
                </div>
              )}
          </FormGroup>
        </Col>
      </Row>
    </>
  );
};
